import { IRestaurantsContext, IFilterValues } from './restaurantsContext';

export enum RestaurantsActionTypes {
	SET_RESTAURANTS = 'SET_RESTAURANTS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_SELECTED_COUNTRY = 'SET_ID_SELECTED_COUNTRY',
	SET_ID_SELECTED_CITY = 'SET_ID_SELECTED_CITY',
	SET_ID_SELECTED_CUSTOMER = 'SET_ID_SELECTED_CUSTOMER',
	SET_IDs_CLIENT_TYPE = 'SET_IDs_CLIENT_TYPE',
	SET_STATUS = 'SET_STATUS',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ARCHIVING = 'SET_ID_FOR_ARCHIVING',
	SET_ID_FOR_RESTORING = 'SET_ID_FOR_RESTORING',
	SET_FULL_INFO_DATA = 'SET_FULL_INFO_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetRestaurants {
	type: RestaurantsActionTypes.SET_RESTAURANTS;
	payload: {
		restaurants: IRestaurantsContext['restaurants'];
		typeOfModalWindow: IRestaurantsContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: RestaurantsActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IRestaurantsContext['searchString'];
	};
}

interface ISetIDCountry {
	type: RestaurantsActionTypes.SET_ID_SELECTED_COUNTRY;
	payload: {
		IDSelectedCountry: IRestaurantsContext['IDSelectedCountry'];
	};
}

interface ISetIDCity {
	type: RestaurantsActionTypes.SET_ID_SELECTED_CITY;
	payload: {
		IDSelectedCity: IRestaurantsContext['IDSelectedCity'];
	};
}

interface ISetIDCustomer {
	type: RestaurantsActionTypes.SET_ID_SELECTED_CUSTOMER;
	payload: {
		IDSelectedCustomer: IRestaurantsContext['IDSelectedCustomer'];
	};
}

interface ISetClientType {
	type: RestaurantsActionTypes.SET_IDs_CLIENT_TYPE;
	payload: {
		IDsSelectedClientType: IRestaurantsContext['IDsSelectedClientType'];
	};
}

interface ISetStatus {
	type: RestaurantsActionTypes.SET_STATUS;
	payload: {
		status: IRestaurantsContext['status'];
	};
}

interface IResetSelectedControls {
	type: RestaurantsActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: RestaurantsActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IRestaurantsContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: RestaurantsActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IRestaurantsContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: RestaurantsActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IRestaurantsContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: RestaurantsActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IRestaurantsContext['IDForDeletion'];
		typeOfModalWindow: IRestaurantsContext['typeOfModalWindow'];
	};
}

interface ISetIDForArchiving {
	type: RestaurantsActionTypes.SET_ID_FOR_ARCHIVING;
	payload: {
		IDForArchiving: IRestaurantsContext['IDForArchiving'];
		typeOfModalWindow: IRestaurantsContext['typeOfModalWindow'];
	};
}

interface ISetIDForRestoring {
	type: RestaurantsActionTypes.SET_ID_FOR_RESTORING;
	payload: {
		IDForRestoring: IRestaurantsContext['IDForRestoring'];
		typeOfModalWindow: IRestaurantsContext['typeOfModalWindow'];
	};
}

interface ISetFullInfoData {
	type: RestaurantsActionTypes.SET_FULL_INFO_DATA;
	payload: {
		fullInfoData: IRestaurantsContext['fullInfoData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: RestaurantsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IRestaurantsContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: RestaurantsActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TRestaurantsAction =
	| ISetRestaurants
	| IChangeSearchString
	| ISetIDCountry
	| ISetIDCity
	| ISetIDCustomer
	| ISetClientType
	| ISetStatus
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForArchiving
	| ISetIDForRestoring
	| ISetFullInfoData
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
